import { useFormik } from 'formik';
import * as Yup from 'yup';

import { Container } from "../../../components/Container"
import { BackButtonAndTitle } from "../../../components/BackButtonAndTitle"
import { TextField, InputLabel, Button } from "@mui/material"
import { FormContainer } from "../../../components/form/FormContainer"
import { TextFieldContainer } from "../../../components/form/TextFieldContainer"

import { AddressAutoComplete } from "../../../components/AddressAutoComplete"
import { useState } from "react"
import { Place } from "../../../types/Place"
import { ErrorMessage } from '../../../components/ErrorMessage';
import { Loader } from '../../../components/Loader';
import { useMutation } from '@apollo/client';
import { useNavigate } from 'react-router-dom';

import { loader } from 'graphql.macro';
const CREATE_SORTING_CENTER = loader("../../../graphql/admin/sortingCenter/mutation/createSortingCenter.graphql");

export const CreateSortingCenter = () => {
    const navigate = useNavigate()
    const [addressError, setAddressError] = useState<string>()
    let [createSortingCenter, { data, loading, error }] = useMutation(CREATE_SORTING_CENTER);
    const [selectedPlace, setSelectedPlace] = useState<Place>({
        address: "",
        zipCode: "",
        city: "",
        latitude: 0,
        longitude: 0
    })

    const formik = useFormik({
        initialValues: {
            name: '',
            address: "",
            zipCode: "",
            city: "",
            latitude: 0,
            longitude: 0
        },
        validationSchema: Yup.object({
            name: Yup.string().required('Le nom du point de collecte est requis'),
        }),
        onSubmit: async values => {
            values.address = selectedPlace.address
            values.zipCode = selectedPlace.zipCode
            values.city = selectedPlace.city
            values.latitude = selectedPlace.latitude
            values.longitude = selectedPlace.longitude
            if (values.address == "" || (values.latitude == 0 && values.longitude == 0) || values.city == "") {
                return setAddressError("L'adresse est incomplète")
            }

            await createSortingCenter({
                variables: values,
                onCompleted: () => {
                    formik.resetForm();
                    navigate(-1)
                }
            })
        }
    })

    return (
        <Container>
            <BackButtonAndTitle title="Nouveau centre de tri" />
            <FormContainer>
                <form onSubmit={formik.handleSubmit}>
                    <TextFieldContainer>
                        <InputLabel>Nom du centre de tri</InputLabel>
                        <TextField
                            id="name"
                            label="Nom"
                            variant="outlined"
                            fullWidth
                            margin="dense"
                            {...formik.getFieldProps('name')}
                            error={formik.touched.name && formik.errors.name ? true : false}
                            helperText={formik.touched.name && formik.errors.name}
                        />
                    </TextFieldContainer>

                    <TextFieldContainer>
                        <AddressAutoComplete setSelectedPlace={setSelectedPlace} />
                    </TextFieldContainer>

                    {error && <ErrorMessage>Une errreur est survenue...</ErrorMessage>}
                    {addressError && <ErrorMessage>{addressError}</ErrorMessage>}
                    {!loading && <Button variant="contained" style={{ marginTop: 20 }} type="submit">Créer le centre</Button>}
                    {loading && <Loader />}
                </form>
            </FormContainer>
        </Container>
    )
}